import { ServicesConfig } from '@nab/x-types';

const getEnvironmentEndpoints = (environment: string): { baseUrl: string } => {
	switch (environment?.toUpperCase()) {
		case 'PROD':
			return { baseUrl: 'https://customer.api.extnp.nab.com.au' };
		case 'SIT4':
			return { baseUrl: 'https://customer-sit4.api.extnp.nab.com.au' };
		case 'SIT5':
			return { baseUrl: 'https://customer-sit5.api.extnp.nab.com.au' };
		default:
			return { baseUrl: 'https://customer-sit1.api.extnp.nab.com.au' };
	}
};

export const getFraudInteractionConfig = (config, environment?: string): Partial<ServicesConfig> => {
	const { baseUrl } = getEnvironmentEndpoints(environment);

	return {
		interaction: {
			endpoint: `${baseUrl}/v1/rt-trace/interactions`,
			sessionEndpoint: `${baseUrl}/v1/rt-trace/session`,
		},
	};
};
